package services.http

import kotlin.uuid.Uuid
import io.ktor.client.*
import io.ktor.client.call.*
import io.ktor.client.request.HttpRequestBuilder
import it.neckar.ktor.client.featureFlagsHeader
import it.neckar.lizergy.comments.client.DuplicateCommentsRequest
import it.neckar.lizergy.comments.client.FetchAllCommentsResponse
import it.neckar.lizergy.comments.client.FetchCommentsForComponentResponse
import it.neckar.lizergy.comments.client.SaveCommentResponse
import it.neckar.lizergy.comments.model.Comment
import it.neckar.ktor.client.get
import it.neckar.ktor.client.putJson
import it.neckar.ktor.client.safeTryFetch

/**
 * Stores / retrieves information using REST
 */
class CommentsClientService(val httpClient: HttpClient, val urlSupport: PlannerUrlSupport) {

  suspend fun fetchAllComments(additionalRequestConfiguration: HttpRequestBuilder.() -> Unit = {}): FetchAllCommentsResponse {
    return safeTryFetch(FetchAllCommentsResponse.bad()) {
      httpClient
        .get(urlSupport.comments.allComments()) {
          featureFlagsHeader()
          additionalRequestConfiguration()
        }.plannerBody(FetchAllCommentsResponse.serializer())
    }
  }

  suspend fun fetchCommentsForComponent(commentsFor: Uuid, additionalRequestConfiguration: HttpRequestBuilder.() -> Unit = {}): FetchCommentsForComponentResponse {
    return safeTryFetch(FetchCommentsForComponentResponse.bad()) {
      httpClient
        .get(urlSupport.comments.comments(commentsFor)) {
          featureFlagsHeader()
          additionalRequestConfiguration()
        }.plannerBody(FetchCommentsForComponentResponse.serializer())
    }
  }

  @IgnorableReturnValue
  suspend fun sendComment(commentFor: Uuid, newComment: Comment, additionalRequestConfiguration: HttpRequestBuilder.() -> Unit = {}): SaveCommentResponse {
    return safeTryFetch(SaveCommentResponse.bad()) {
      httpClient
        .putJson(urlSupport.comments.comments(commentFor), newComment) {
          featureFlagsHeader()
          additionalRequestConfiguration()
        }.plannerBody(SaveCommentResponse.serializer())
    }
  }

  @IgnorableReturnValue
  suspend fun duplicateComments(mapOfOldToNewUuids: Map<Uuid, Uuid>, additionalRequestConfiguration: HttpRequestBuilder.() -> Unit = {}): SaveCommentResponse {
    return safeTryFetch(SaveCommentResponse.bad()) {
      httpClient
        .putJson(urlSupport.comments.duplicateComments(), DuplicateCommentsRequest(mapOfOldToNewUuids)) {
          featureFlagsHeader()
          additionalRequestConfiguration()
        }.plannerBody(SaveCommentResponse.serializer())
    }
  }

}
